import layoutHeaderAside from '@/layout/header-aside'

const meta = { auth: true }

export default {
  path: '/approve',
  title: '审批流管理',
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'approval',
      name: `${pre}approval`,
      meta: { ...meta, cache: true, title: '流程设计' },
      component: () => import('@/views/approve/approval')
    },
    {
      path: 'formDesigner',
      name: `${pre}formDesigner`,
      meta: { ...meta, cache: true, title: '表单设计' },
      component: () => import('@/views/approve/formDesigner')
    },
    {
      path: 'formDisplay',
      name: `${pre}formDisplay`,
      meta: { ...meta, cache: true, title: '创建表单' },
      component: () => import('@/views/approve/formDisplay')
    },
    {
      path: 'formDisplayList',
      name: `${pre}formDisplayList`,
      meta: { ...meta, cache: true, title: '表单列表' },
      component: () => import('@/views/approve/formDisplayList')
    },
  ])('approve-')
}
